import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { parse, isValid, addYears } from 'date-fns';
import { fg } from '@atlaskit/platform-feature-flags';
import { getPluginState } from '../../plugin-factory';
import { Cache } from '../utils';
import { DATE_FORMATS_BY_LOCALE_LIST, LOCALES_LIST } from './date-formats-by-locale';
export var LocaleManager = /*#__PURE__*/function () {
  function LocaleManager() {
    _classCallCheck(this, LocaleManager);
  }
  return _createClass(LocaleManager, null, [{
    key: "getSelectedLocale",
    value: function getSelectedLocale(state) {
      var pluginState = getPluginState(state);
      return (pluginState === null || pluginState === void 0 ? void 0 : pluginState.locale) || 'en-US';
    }
  }]);
}();
_defineProperty(LocaleManager, "LOCALES", LOCALES_LIST);
export var DateParser = /*#__PURE__*/function () {
  function DateParser() {
    _classCallCheck(this, DateParser);
  }
  return _createClass(DateParser, null, [{
    key: "isPotentialDateString",
    value: function isPotentialDateString(input) {
      return this.REGEXES.DIGITS.test(input) && input.length >= this.MIN_DATE_LENGTH && input.length <= this.MAX_DATE_LENGTH;
    }
  }, {
    key: "containsAmbiguousMonth",
    value: function containsAmbiguousMonth(input) {
      var matches = input.match(this.REGEXES.ALL_ALPHABET_CHARS);
      if (!matches) {
        return false;
      }
      var longestTokenLength = matches.reduce(function (max, token) {
        return Math.max(max, token.length);
      }, 0);
      return longestTokenLength <= 2;
    }
  }, {
    key: "isPartialNumericFormat",
    value: function isPartialNumericFormat(format) {
      if (format.includes('y')) {
        return false;
      }
      if (format.includes('MMM') || format.includes('do')) {
        return false;
      }
      return true;
    }
  }, {
    key: "normaliseYear",
    value: function normaliseYear(date) {
      var year = date.getFullYear();
      if (year < 100) {
        date = addYears(date, year < this.SHORT_YEAR_CUTOFF ? 2000 : 1900);
      } else if (year < 1000) {
        date = addYears(date, 2000);
      }
      return date;
    }
  }, {
    key: "analyzeDelimiters",
    value: function analyzeDelimiters(input) {
      var delimiterMatches = input.match(this.REGEXES.ALL_DATE_DELIMITERS) || [];
      var uniqueDelims = new Set(delimiterMatches);
      var hasMixedDelimiters = uniqueDelims.size > 1;
      var trailingCharMatch = input.match(this.REGEXES.TRAILING_DATE_DELIMITER);
      var trailingDelimiter = null;
      var strippedInput = input;
      if (trailingCharMatch) {
        trailingDelimiter = trailingCharMatch[0];
        strippedInput = input.slice(0, -1);
      }
      return {
        hasMixedDelimiters: hasMixedDelimiters,
        trailingDelimiter: trailingDelimiter,
        strippedInput: strippedInput
      };
    }
  }, {
    key: "tryAllFormats",
    value: function tryAllFormats(strippedInput, trailingDelimiter, locale) {
      var _this = this;
      var dateFnsLocale = LocaleManager.LOCALES[locale];
      var formats = this.DATE_FORMATS_BY_LOCALE[locale];
      if (!fg('platform_editor_ai_suggestions_partial_dates')) {
        formats = formats.filter(function (format) {
          return !_this.isPartialNumericFormat(format);
        });
      }
      var _iterator = _createForOfIteratorHelper(formats),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var format = _step.value;
          var parsed = parse(strippedInput, format, new Date(), {
            locale: dateFnsLocale
          });
          if (isValid(parsed)) {
            return {
              date: this.normaliseYear(parsed),
              matchedFormat: format,
              trailingDelimiter: trailingDelimiter
            };
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "parse",
    value: function parse(input, locale) {
      var _this2 = this;
      if (!this.isPotentialDateString(input) || this.containsAmbiguousMonth(input)) {
        return null;
      }
      var _this$analyzeDelimite = this.analyzeDelimiters(input),
        hasMixedDelimiters = _this$analyzeDelimite.hasMixedDelimiters,
        trailingDelimiter = _this$analyzeDelimite.trailingDelimiter,
        strippedInput = _this$analyzeDelimite.strippedInput;
      if (hasMixedDelimiters) {
        return null;
      }
      return this.cache.get("".concat(locale, ":").concat(input), function () {
        return _this2.tryAllFormats(strippedInput, trailingDelimiter, locale);
      });
    }
  }, {
    key: "extractDelimiterFromFormat",
    value: function extractDelimiterFromFormat(matchedFormat) {
      var _matchedFormat$match$, _matchedFormat$match;
      return (_matchedFormat$match$ = (_matchedFormat$match = matchedFormat.match(this.REGEXES.NON_ALPHABET_CHARS)) === null || _matchedFormat$match === void 0 ? void 0 : _matchedFormat$match[0]) !== null && _matchedFormat$match$ !== void 0 ? _matchedFormat$match$ : ' ';
    }
  }]);
}();
_defineProperty(DateParser, "MIN_DATE_LENGTH", 3);
_defineProperty(DateParser, "MAX_DATE_LENGTH", 20);
_defineProperty(DateParser, "SHORT_YEAR_CUTOFF", 60);
_defineProperty(DateParser, "DATE_FORMATS_BY_LOCALE", DATE_FORMATS_BY_LOCALE_LIST);
_defineProperty(DateParser, "REGEXES", {
  TRAILING_DATE_DELIMITER: /[\x2D-\/]$/,
  ALL_DATE_DELIMITERS: /[\x2D-\/]/g,
  NON_ALPHABET_CHARS: /(?:[\0-@\[-`\{-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/,
  ALL_ALPHABET_CHARS: /[A-Za-z]+/g,
  DIGITS: /[0-9]/
});
_defineProperty(DateParser, "cache", new Cache());
export var DateUtils = /*#__PURE__*/function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }
  return _createClass(DateUtils, null, [{
    key: "getDateOnlyUtcTimestamp",
    value: function getDateOnlyUtcTimestamp(date) {
      return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    }
  }, {
    key: "canInsertDateNode",
    value: function canInsertDateNode(state, pos) {
      var _state$schema;
      var dateType = state === null || state === void 0 || (_state$schema = state.schema) === null || _state$schema === void 0 || (_state$schema = _state$schema.nodes) === null || _state$schema === void 0 ? void 0 : _state$schema.date;
      if (!dateType) {
        return false;
      }
      var $pos = state.doc.resolve(pos);
      return $pos.parent.canReplaceWith($pos.index(), $pos.index(), dateType);
    }
  }]);
}();
export var CursorPhraseUtils = /*#__PURE__*/function () {
  function CursorPhraseUtils() {
    _classCallCheck(this, CursorPhraseUtils);
  }
  return _createClass(CursorPhraseUtils, null, [{
    key: "sortByDescendingRangeLength",
    value: function sortByDescendingRangeLength(phrases) {
      return phrases.slice().sort(function (a, b) {
        var aLength = a.to - a.from;
        var bLength = b.to - b.from;
        return bLength - aLength;
      });
    }
  }, {
    key: "findFirstValidDatePhrase",
    value: function findFirstValidDatePhrase(phrases, locale) {
      var _iterator2 = _createForOfIteratorHelper(phrases),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var phrase = _step2.value;
          var result = DateParser.parse(phrase.phrase, locale);
          if (result) {
            return {
              phrase: phrase,
              result: result
            };
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return null;
    }
  }]);
}();